// extracted by mini-css-extract-plugin
module.exports = {"badge":"CharacterShopBadge_badge__32kmN","title":"CharacterShopBadge_title__a0a34"};